import { Component, OnInit } from "@angular/core";
import { CommonService } from "../shared/common.service";
import { Intercom } from "ng-intercom";
@Component({
  selector: "app-main",
  templateUrl: "./main.component.html",
  styleUrls: ["./main.component.css"],
})
export class MainComponent implements OnInit {
  constructor(public intercom: Intercom) {}

  ngOnInit() {
    // this.initilizeInterComm();
  }
  initilizeInterComm() {
    let userData = JSON.parse(localStorage.getItem("userData")) || "noemail";
    console.log(userData);

    this.intercom.boot({
      app_id: "bn64enia",
      name: userData.name, // Full name
      email: userData.email,
      // Supports all optional configuration.
      widget: {
        activator: "#intercom",
      },
    });
  }
}
